import { motion, useScroll, useSpring } from 'framer-motion';

export default function ProgressBar() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-1.5 origin-[0%] z-50 bg-gradient-to-r from-[var(--color-uf-blue)] to-[var(--color-uf-orange)]"
      style={{ scaleX }}
    />
  );
}
